import {Component, computed, inject} from '@angular/core';
import {ButtonsSelectComponent, PopupToggleComponent, SvgSpriteIcon} from '@selpia/shared/ui';
import {SortingStrategyId} from '@selpia/shared/models';
import {FormsModule} from '@angular/forms';
import {NavigationService} from '@selpia/data-batch/history-access';
import {OptionsFacade} from '@selpia/options/data-access';

interface SortingOption {
  label: string;
  icon: SvgSpriteIcon;
  sortingType: SortingStrategyId;
  disabled?: boolean;
}

@Component({
  selector: 'lib-feature-sorting-selector',
  imports: [PopupToggleComponent, ButtonsSelectComponent, FormsModule],
  templateUrl: './feature-sorting-selector.component.html',
  styleUrl: './feature-sorting-selector.component.scss',
})
export class FeatureSortingSelectorComponent {
  readonly #navigationService = inject(NavigationService);
  readonly #optionsFacade = inject(OptionsFacade);

  protected readonly SvgSpriteIcon = SvgSpriteIcon;

  protected readonly sortingOptions: SortingOption[] = [
    {
      label: 'Tile Name A-Z',
      icon: SvgSpriteIcon.SortAlphabetAsc,
      sortingType: SortingStrategyId.AlphabeticAsc,
    },
    {
      label: 'Tile Name Z-A',
      icon: SvgSpriteIcon.SortAlphabetDesc,
      sortingType: SortingStrategyId.AlphabeticDesc,
    },
    {
      label: 'Ascending by Key Metric',
      icon: SvgSpriteIcon.SortAsc,
      sortingType: SortingStrategyId.FocusMeasureAsc,
    },
    {
      label: 'Descending by Key Metric',
      icon: SvgSpriteIcon.SortDesc,
      sortingType: SortingStrategyId.FocusMeasureDesc,
    },
  ];

  readonly selectedSorting = computed(() => {
    const sortType = this.#optionsFacade.sortType();
    return this.sortingOptions.find(option => option.sortingType === sortType) || this.sortingOptions[0];
  });

  updateSelectedSorting(sorting: SortingOption): void {
    this.#navigationService.setSortType(sorting.sortingType);
  }
}
